export const LABEL_FOLDER_KEY = "folder:";
export const AUTO_ATTACHMENT_KEY = "autoattach:";
